import styled from 'styled-components';

export const LiveFeedPlaysWrapper = styled.div``;
